import DuckEntityForm from "ducks/DuckEntityForm";
import DuckEntity from 'ducks/DuckEntity';
import PageableDuck from 'ducks/PageableDuck';

const customerLedgerItems = new PageableDuck('customerLedgerItems');
const customerLedgerItemForm = new DuckEntityForm('customerLedgerItemForm', customerLedgerItems);

export {customerLedgerItems, customerLedgerItemForm};
